import React from 'react'
import { useLocation, useNavigate } from "react-router-dom";

import { PokeCard } from '../../../Components/Player/PokeCard';
import { useMediaQuery } from 'react-responsive';

export const PokedexDetail = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const numero_pokedex = queryParams.get("n_pokedex");
    const navigate = useNavigate();
    const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });

  return (
    <>
      {
        isDesktopOrLaptop ? navigate("/404") : <PokeCard id={ numero_pokedex }/>
      }
    </>
  )
}
